module.exports = __webpack_public_path__ + "static/media/Etape1-Formulaire-Option-n1.0feded83.png";